import { Component } from "react"
import API from "flux/api/api"
import Icon from "components/planning_center_icon"
import { StackView, Button } from "@planningcenter/tapestry-react"

class ManageCategories extends Component {
  constructor(props) {
    super(props)

    this.state = {
      categories: {},
      loadingCategories: true,
      newCategoryName: ""
    }

    this.handleAddNewCategory = this.handleAddNewCategory.bind(this)
    this.refreshCategories = this.refreshCategories.bind(this)
  }

  componentDidMount() {
    API.getAll("/categories?order=name", { perPage: 100 }).then(resp =>
      this.setState({ categories: resp, loadingCategories: false })
    )
  }

  render() {
    const { categories, loadingCategories, newCategoryName } = this.state

    if (loadingCategories) {
      return <div className="ta-c c-secondary">Loading...</div>
    } else {
      return (
        <div>
          <div className="d-f ai-c">
            <input
              type="text"
              placeholder="Add new category"
              value={newCategoryName}
              onKeyUp={e => {
                if (e.keyCode === 13) {
                  this.handleAddNewCategory()
                }
              }}
              onChange={e => this.setState({ newCategoryName: e.target.value })}
            />
            <button className="ml-1 btn-solid interaction" onClick={this.handleAddNewCategory}>
              <Icon symbol="general#plus" aria-label="Submit new category" />
            </button>
          </div>
          {!!categories.data.length && (
            <ul className="unstyled m-0 pt-1">
              {categories.data.map(c => (
                <CategoryRow
                  key={c.id}
                  {...c}
                  afterDestroy={this.refreshCategories}
                  afterUpdate={this.refreshCategories}
                />
              ))}
            </ul>
          )}
        </div>
      )
    }
  }

  refreshCategories() {
    const { afterChange } = this.props

    API.getAll("/categories?order=name", { perPage: 100 }).then(resp => {
      this.setState({ categories: resp, loadingCategories: false })
      afterChange && afterChange(resp)
    })
  }

  handleAddNewCategory() {
    API.post("/categories", { attributes: { name: this.state.newCategoryName } }, resp => {
      if (resp.errors) {
        this.setState({ busy: false })
        alertModal({
          type: "error",
          title: "An error occured",
          text: resp.errors.map(e => e.detail).join(", "),
          confirmButtonText: "Ok"
        })
      } else {
        this.setState({ newCategoryName: "" }, this.refreshCategories())
      }
    })
  }
}

class CategoryRow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editing: false,
      initialEdit: false,
      name: props.attributes.name
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDestroy = this.handleDestroy.bind(this)
  }

  componentDidUpdate() {
    if (this.state.initialEdit) {
      this.input.select()
      this.setState({ initialEdit: false })
    }
  }

  render() {
    const { editing, name } = this.state

    if (editing) {
      return (
        <StackView
          as="li"
          axis="horizontal"
          alignment="center"
          distribution="space-between"
          marginTop={1}
          className="category-row__item"
        >
          <div className="category-row__item-input">
            <input
              ref={r => (this.input = r)}
              type="text"
              value={name}
              onKeyUp={e => {
                if (e.keyCode === 13) {
                  this.handleSubmit()
                }
              }}
              onChange={e => this.setState({ name: e.target.value })}
              autoFocus
            />
          </div>
          <StackView axis="horizontal" spacing={1} className="category-row__actions">
            <Button
              theme="flat"
              icon={{ name: "general.check" }}
              title="Save category changes"
              aria-label="Save category changes"
              onClick={this.handleSubmit}
            />
            <Button
              theme="flat"
              icon={{ name: "general.x" }}
              title="Cancel category changes"
              aria-label="Cancel category changes"
              onClick={() => this.setState({ editing: false, name: this.props.attributes.name })}
            />
          </StackView>
        </StackView>
      )
    } else {
      return (
        <StackView
          as="li"
          axis="horizontal"
          alignment="center"
          distribution="space-between"
          marginTop={1}
          className="category-row__item"
        >
          <span className="category-row__item-title">{name}</span>
          <StackView axis="horizontal" spacing={1} className="category-row__actions">
            <Button
              theme="flat"
              icon={{ name: "general.pencil" }}
              title="Edit category"
              aria-label="Edit category"
              onClick={() => this.setState({ editing: true, initialEdit: true })}
            />
            <Button
              theme="flat"
              icon={{ name: "general.trash" }}
              title="Delete category"
              aria-label="Delete category"
              onClick={this.handleDestroy}
            />
          </StackView>
        </StackView>
      )
    }
  }

  handleDestroy() {
    const { id, afterDestroy } = this.props

    alertModal(
      {
        title: "Delete category?",
        text: "This will delete the category, but will not delete the signups in this category.",
        type: "warning",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
        customClass: "destructive-warning",
        showCancelButton: true
      },
      () =>
        API.del(`/categories/${id}`, resp => {
          if (resp.errors) {
            this.setState({ busy: false })
            alertModal({
              type: "error",
              title: "An error occcured",
              text: resp.errors.map(e => e.detail).join(", "),
              confirmButtonText: "Ok"
            })
          } else {
            this.setState({ editing: false })
            afterDestroy()
          }
        })
    )
  }

  handleSubmit() {
    const { id, afterUpdate } = this.props
    const { name } = this.state

    API.patch(`/categories/${id}`, { attributes: { name } }, resp => {
      if (resp.errors) {
        this.setState({ busy: false })
        alertModal({
          type: "error",
          title: "An error occured",
          text: resp.errors.map(e => e.detail).join(", "),
          confirmButtonText: "Ok"
        })
      } else {
        this.setState({ editing: false })
        afterUpdate()
      }
    })
  }
}

export default ManageCategories
